import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';
import CTA from '../components/CTA';

export default function FAQPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0b] flex flex-col">
      <Navbar />
      <main className="flex-1">
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
